// Common
import Sidebar from './components/commons/sidebar';

import Footer from './components/commons/footer';

// Login
// import Login from './components/authentication/login';


// import LoginUR from './components/authentication/login_cr';

// Maintenance
import Maintenance from './components/authentication/maintenance';

// remove newsletter subscribing
import Subscribing from './components/subscribing/main';

// Coach
import Coach from './components/adm/coach';
import UserCoach from './components/adm/users';
import EmailCoach from './components/adm/email';






import TeamOverview from './components/team/list_overview';


// Auction
import Auction from './components/auction/main';
import AuctionMap from './components/auction/map';
import AuctionList from './components/auction/list';
import AuctionArchive from './components/auction/archive';
import AuctionOperation from './components/auction/operation/main';
import AuctionOverview from './components/auction/overview';
import AuctionInfo from './components/auction/info';
import Abread from './components/auction/breadcrumb';
import AuctionIncome from './components/customfreeauction/customfreeauction';
import AuctionOperationBread from './components/auction/operation/breadcrumb';
import AuctionMapping from './components/auction/mapping';
import BreadAuctionMapping from './components/auction/breadcrumb_auction_mapping';

// Custom
import CustomBuilding from './components/custom/building_card';
import CustomInfo from './components/custom/2_info';
import CustomTeam from './components/custom/3_team_overview';
import CustomBread from './components/custom/breadcrumb';


// Common Todo
import TodoOperation from './components/commons/todo_operation';

import CalendarOperation from './partials/dashboard/calendar';


// CustomFree
import CustomFree from './components/customfree/customfreedata';


import Stats from './components/adm/stats';

// Version 2.x
import N_Dashboard from '@/pages/dashboard/main';
import N_Mapping from '@/pages/mapping/main';
import N_Auction from '@/pages/auction/main';
import N_SearchMap from '@/pages/mapping/search_map';
import N_Team from '@/pages/team/main';
import N_News from '@/pages/news/main';
import N_Pills from '@/pages/pills/main';
import N_Purpose from '@/pages/purpose/main';
import N_Version from '@/pages/version/main';
import N_AuctionMap from '@/pages/auction/auction_map';
import N_IncomeMapping from '@/pages/income/mapping';
import N_StarredMapping from '@/pages/starred/main_mapping';
import N_StarredAuction from '@/pages/starred/main_auction';
import N_Login from '@/pages/login/login';
import N_es from '@/pages/login/es';
import N_it from '@/pages/login/it';
import N_LoginUR from '@/pages/login/login_cr';
import N_Topheader from '@/partials/top';
import N_Tutorial from '@/pages/tutorial/main';
import N_SuperCoach from '@/pages/supercoach/index';
import N_MyTask from '@/pages/supercoach/user_index';
import N_Trash from '@/pages/trash/index';
import N_info_compravendita from "@/pages/services/info_compravendita";
import N_info_catasto from "@/pages/services/info_catasto";
import N_catasto from "@/pages/services/catasto";
import N_info_idealista from "@/pages/services/info_idealista";
import N_compravendita from "@/pages/services/compravendita";
import N_info_wallet from '@/pages/wallet/main';
import N_google_auth from '@/components/calendar/auth.vue';
import N_google_callback from '@/components/calendar/callback.vue';
// End Version 2.x

export const routes = [

    {
        path: '/google/auth',
        name: 'N_google_auth',
        components: {
            default: N_google_auth,
        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/google/callback',
        name: 'N_google_callback',
        components: {
            default: N_google_callback,
        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/tutorial',
        name: 'N_Tutorial',
        components: {
            default: N_Tutorial,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/services/wallet',
        name: 'N_info_wallet',
        components: {
            default: N_info_wallet,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },



    {
        path: '/services/info_catasto',
        name: 'N_info_catasto',
        components: {
            default: N_info_catasto,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/services/catasto',
        name: 'N_catasto',
        components: {
            default: N_catasto,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },


    {
        path: '/services/info_idealista',
        name: 'N_info_idealista',
        components: {
            default: N_info_idealista,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/services/info_compravendita',
        name: 'N_info_compravendita',
        components: {
            default: N_info_compravendita,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/services/compravendita',
        name: 'N_compravendita',
        components: {
            default: N_compravendita,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/trash',
        name: 'N_Trash',
        components: {
            default: N_Trash,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/login',
        name: 'N_Login',
        components: {
            default: N_Login,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/es',
        name: 'N_es',
        components: {
            default: N_es,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/it',
        name: 'N_it',
        components: {
            default: N_it,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },


    {
        path: '/starred/mapping',
        name: 'N_StarredMapping',
        components: {
            default: N_StarredMapping,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/starred/auction',
        name: 'N_StarredAuction',
        components: {
            default: N_StarredAuction,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/income/:id?/:customId?',
        name: 'N_IncomeMapping',
        components: {
            default: N_IncomeMapping,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/version',
        name: 'N_Version',
        components: {
            default: N_Version,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,

        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/purpose',
        name: 'N_Purpose',
        components: {
            default: N_Purpose,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,

        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/pills',
        name: 'N_Pills',
        components: {
            default: N_Pills,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/news',
        name: 'N_News',
        components: {
            default: N_News,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/team',
        name: 'N_Team',
        components: {
            default: N_Team,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/auction',
        name: 'N_Auction',
        components: {
            default: N_Auction,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,

        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/auction/search',
        name: 'N_AuctionMap',
        components: {
            default: N_AuctionMap,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,

        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/mapping/:zone_id?',
        name: 'N_Mapping',
        components: {
            default: N_Mapping,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,

        },
        meta: {middlewareAuth: true},
    },

    {
        path: '/pip',
        name: 'N_Mapping',
        components: {
            default: N_Mapping,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,

        },
        meta: {middlewareAuth: true},
    },


    {
        path: '/mapping/search/:zoneId/:region',
        name: 'N_SearchMap',
        components: {
            default: N_SearchMap,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,

        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/dashboard',
        name: 'N_Dashboard',
        components: {
            default: N_Dashboard,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,

        },
        meta: {middlewareAuth: true},
    },
    {
        path: '/subscribing/:privacy_token',
        components: {
            default: Subscribing
        },
        name: 'Subscribing',
    },

   /* {
        path: '/login',
        components: {
            default: Login
        },
        name: 'Login',

    },*/


    {
        path: '/maintenance',
        components: {
            default: Maintenance
        },
        name: 'Maintenance',

    },

    {
        path: '/login_cr',
        components: {
            default: N_LoginUR
        },
        name: 'LoginUR',

    },





    // {
    //     path: '/auction/create/:page?',
    //     name: 'myAuction',
    //     components: {
    //         topheader: N_Topheader,
    //         sidebar: Sidebar,
    //         footer: Footer,
    //         default: AuctionMap,
    //         overview: AuctionOverview,
    //         heading: Abread,
    //         choose_region: Auction,
    //         partial_archive: AuctionArchive,
    //         list: AuctionList,
    //     },
    //     props: {
    //         default: true,
    //         overview: true,
    //         heading: route => ({
    //             text: 'breadcrumb.auction_title'
    //         })
    //     },
    //     meta: {
    //         requiresAuth: true
    //     }
    // },

    // {
    //     path: '/auction/mapping/create',
    //     name: 'N_AuctionMapping',
    //     components: {
    //         topheader: N_Topheader,
    //         sidebar: Sidebar,
    //         footer: Footer,
    //         default: AuctionMapping,
    //         heading: BreadAuctionMapping,
    //     },
    //     props: {
    //         default: true,
    //         overview: true,
    //         heading: route => ({
    //             text: 'immobiliare.bread_title'  // translating variable name
    //         })
    //     },
    //     meta: {
    //         requiresAuth: true
    //     }
    // },

    {
        path: '/auction_operation/detail/:page?/:customId?',
        components: {
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
            default: AuctionOperation,
            heading: AuctionOperationBread,
            income: AuctionIncome,
            info: AuctionInfo, // different from custom and mapping
            team: TeamOverview,
            todofull: TodoOperation,
            // modal_area: Auction,
        },
        props: {
            default: true,
            income: route => ({
                colorBar: 'card-topline-auction',
                colorHeader: 'abtg__label-color-auction',
                id: route.params.page,
                customId: route.params.customId,
            }),
            team: route => ({
                type: 2,
                page: route.params.page,
            }),
            todofull: route => ({
                type: 2,
                page: route.params.page,
                id: route.params.page,
                colorBar: 'card-topline-auction',
                colorHeader: 'abtg__label-color-auction'
            }),
            info: route => ({
                page: route.params.page,
                colorBar: 'card-topline-auction',
                colorHeader: 'abtg__label-color-auction'
            }),
        },

        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/custom/:id?/:customId?',
        components: {
            heading: CustomBread,
            topheader: N_Topheader,
            sidebar: Sidebar,
            footer: Footer,
            default: CustomBuilding,
            income: CustomFree,
            info: CustomInfo,
            team: CustomTeam,
            todofull: TodoOperation,
            calendaroperation: CalendarOperation,

        },
        props: {
            default: route => ({
                type: 1,
                id: route.params.id,
                page: route.params.id,
                customId: route.params.customId,
            }),

            team: route => ({
                type: 3,
                id: route.params.id,
                page: route.params.id,
            }),
            todofull: route => ({
                type: 3,
                id: route.params.id,
                colorBar: 'card-topline-custom',
                colorHeader: 'abtg__label-color-custom'
            }),
            income: route => ({
                type: 3,
                id: route.params.id,
                customId: route.params.customId,
                colorBar: 'card-topline-custom',
                colorHeader: 'abtg__label-color-custom'
            }),


            info: route => ({
                colorBar: 'card-topline-custom',
                colorHeader: 'abtg__label-color-custom'
            }),
        },

        meta: {
            requiresAuth: true
        }
    },



    {
        path: '/adm/stats',
        components: {
            topheader: N_Topheader,
            footer: Footer,
            default: Stats,
            sidebar: Sidebar,
        },
        props: {
            default: true,
        },

        meta: {
            requiresAuth: true,
            requiresCoach: true,
        }
    },

    {
        path: '/adm/users/:what?',
        components: {
            topheader: N_Topheader,
            footer: Footer,
            default: UserCoach,
            sidebar: Sidebar,
        },
        default: route => ({
            what: route.params.what,
        }),
        props: {
            default: true,
        },

        meta: {
            requiresAuth: true,
            requiresCoach: true,
        }
    },

    {
        path: '/adm/email',
        components: {
            topheader: N_Topheader,
            footer: Footer,
            default: EmailCoach,
            sidebar: Sidebar,
        },
        props: {
            default: true,
        },

        meta: {
            requiresAuth: true,
            requiresCoach: true,
        }
    },



    {
        path: '/adm/coach',
        components: {
            topheader: N_Topheader,
            footer: Footer,
            default: Coach,
            sidebar: Sidebar,
        },
        props: {
            default: true,
        },
        meta: {
            requiresAuth: true,
            requiresCoach: true,
        }
    },

    {
        path: '/mytask',
        name: 'N_Task',
        components: {
            topheader: N_Topheader,
            footer: Footer,
            default: N_MyTask,
            sidebar: Sidebar,
        },
        props: {
            default: true,
        },
        meta: {
            requiresAuth: true,
        }
    },

    {
        path: '/adm/supercoach',
        components: {
            topheader: N_Topheader,
            footer: Footer,
            default: N_SuperCoach,
            sidebar: Sidebar,
        },
        props: {
            default: true,
        },
        meta: {
            requiresAuth: true,
            requiresCoach: true,
        }
    },
];
